import React, { createContext, useState, useEffect, useContext } from 'react';

// Crear el contexto para el tema
export const ThemeContext = createContext();

// Hook personalizado para usar el tema
export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  // Opciones de tema: 'light', 'dark', 'auto'
  const [themePreference, setThemePreference] = useState(() => {
    const savedPreference = localStorage.getItem('themePreference');
    return savedPreference || 'auto';
  });

  // El tema actualmente aplicado: 'light' o 'dark'
  const [currentTheme, setCurrentTheme] = useState('light');

  // Función para verificar si es de noche basado en la hora local
  const isNightTime = () => {
    const hours = new Date().getHours();
    return hours < 6 || hours >= 18; // Entre 6pm y 6am es considerado noche
  };

  // Función para determinar y aplicar el tema correcto
  const applyTheme = () => {
    let theme = 'light';

    if (themePreference === 'auto') {
      theme = isNightTime() ? 'dark' : 'light';
    } else {
      theme = themePreference;
    }

    setCurrentTheme(theme);

    // Aplicar clase al elemento HTML para CSS
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  // Cambiar la preferencia de tema
  const changeTheme = (preference) => {
    setThemePreference(preference);
    localStorage.setItem('themePreference', preference);
  };

  // Aplicar el tema inicial y guardar en localStorage
  useEffect(() => {
    applyTheme();
  }, [themePreference]);

  // Para el modo automático, verificar cambios de hora
  useEffect(() => {
    if (themePreference === 'auto') {
      // Verificar cada minuto si es necesario cambiar entre día y noche
      const interval = setInterval(() => {
        applyTheme();
      }, 60000);

      return () => clearInterval(interval);
    }
  }, [themePreference]);

  return (
    <ThemeContext.Provider value={{ currentTheme, themePreference, changeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};